import gql from "graphql-tag";

// Payload original vem do arquivo de dump (campo resolvido sob demanda), por
// isso é buscado só ao abrir o detalhe — não na listagem. `inventoryItem` e
// `inventoryLocation` resolvem os material_code/location_code do ERP para o
// cadastro do sistema (nome + existe?), para facilitar o debugging.
const SHIPMENT_REQUEST_PAYLOAD_QUERY = gql`
  query ShipmentRequestPayloadQuery($id: Int!) {
    shipmentRequest(id: $id) {
      id
      code
      status
      statusMessage
      materials {
        materialCode
        supplier
        order
        weight
        inventoryItem {
          id
          code
          name
          exists
        }
        locations {
          locationCode
          weight
          inventoryLocation {
            id
            code
            name
            exists
          }
        }
      }
      originalPayload
    }
  }
`;

export default SHIPMENT_REQUEST_PAYLOAD_QUERY;
